import { Component } from "@angular/core";

import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-upload-error-component",
  templateUrl: "./upload-error.component.html",
  styleUrls: ["./upload-error.component.scss"]
})
export class UploadErrorDialog {
  constructor(private dialogRef: MatDialogRef<UploadErrorDialog>) {}

  closePopup() {
    this.dialogRef.close();
  }
}
